import Slider from 'react-slick'
import { moment_date, handleUrlArticle } from 'Helpers/utils'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const BannerHomeDesktop = (props) => {
  const ArrowLeft = ({ currentSlide, slideCount, ...props }) => (
      <button
        {...props}
        id={`btn_prev_${props.elem}`}
        aria-label="prev-slide"
      />
    ),
    ArrowRight = ({ currentSlide, slideCount, ...props }) => (
      <button
        {...props}
        id={`btn_next_${props.elem}`}
        aria-label="next-slide"
      />
    ),
    slider_settings = {
      arrows: true,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <ArrowRight elem="banner" />,
      prevArrow: <ArrowLeft elem="banner" />,
    }
  return (
    <div className="homepage-article-slider">
      <Slider {...slider_settings}>
        {Array.isArray(props.sponsoredPost)
          ? props.sponsoredPost.length
            ? props.sponsoredPost.map((item, id) => (
                <div className="homepage-slider-item" key={id}>
                  <div className="homepage-banner">
                    <div className="homepage-banner-img">
                      <a href={handleUrlArticle(item.url)} rel="noreferrer">
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                          }}
                        >
                          <ImageFallback
                            src={item.image}
                            alt={item.title}
                            objectFit="cover"
                            layout="fill"
                            priority
                            // quality={80}
                            fallbackSrc={vars.imageBrokenDefault.rectangle1}
                          />
                        </div>
                      </a>
                    </div>
                    <div className="homepage-banner-content">
                      <div className="homepage-banner-inner-content">
                        <a href={handleUrlArticle(item.url)} rel="noreferrer">
                          <h4 className="homepage-banner-title-content">
                            {item.title}
                          </h4>
                        </a>
                        <p className="homepage-banner-timestamp">
                          <b>{moment_date({ date: item.created_at })}</b>
                          &nbsp;by&nbsp;
                          <b>
                            <a
                              href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                            >
                              <i>{item.author.name}</i>
                            </a>
                          </b>
                        </p>
                        <p className="homepage-banner-description-content">
                          {item.excerpt}
                        </p>
                        <a href={handleUrlArticle(item.url)}>
                          View article detail
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : null
          : null}
      </Slider>
      <style>
        {`
        .homepage-banner {
          display: flex;
          padding: 0;
          align-items: center;
          height: 500px;
          position: relative;
          max-width: 100vw;
        }

        .homepage-banner-img {
          height: 500px;
          width: 100%;
          z-index: 1;
          overflow: hidden;
        }

        .homepage-banner-img a {
          text-decoration: none;
        }

        .homepage-banner-img a img {
          min-height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: 50% 50%;
          cursor: pointer;
        }

        .homepage-banner-content {
          position: absolute;
          right: 94px;
          background: #FFFFFF;
          max-width: 478px;
          padding: 24px;
          z-index: 1;
          margin: auto;
          overflow: hidden;
        }

        .homepage-banner-inner-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          border: 1px solid #DFE3E8;
          padding: 36px;
        }

        .homepage-banner-title-content {
          font-family: Josefin Sans, sans-serif;
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 32px;
          letter-spacing: -0.03em;
          text-align: center;
          margin-bottom: 24px;
          color: #000;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .homepage-banner-description-content {
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: center;
          margin: 0 0 16px 0;
        }

        .homepage-banner-timestamp {
          font-family: Roboto;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 10px;
          letter-spacing: 0px;
          text-align: center;
          color: #637381;
          margin: 0 0 24px 0;
        }

        .homepage-banner-timestamp b, .homepage-banner-timestamp i {
          font-weight: bold;
        }

        .homepage-banner-inner-content a {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          letter-spacing: 0.1em;
          color: #DB284E;
          text-transform: uppercase;
        }

        {/* slider custom styles */}
        .homepage-article-slider .slick-slider {
          max-width: 100vw;
        }

        .homepage-article-slider .slick-prev,
        .homepage-article-slider .slick-next {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 0px 3px 10px rgba(145, 158, 171, 0.2);
          z-index: 1;
        }

        .homepage-article-slider .slick-prev {
          left: 24px;
        }

        .homepage-article-slider .slick-prev::before {
          content: '❮';
        }

        .homepage-article-slider .slick-next {
          right: 24px;
        }

        .homepage-article-slider .slick-next::before {
          content: '❯';
        }

        .homepage-article-slider .slick-prev::before,
        .homepage-article-slider .slick-next::before {
          position: absolute;
          transform: translate(-6.5px, -13px);
          color: #000;
        }

        .homepage-article-slider .slick-dots {
          bottom: 38px;
        }

        .homepage-article-slider .slick-dots li,
        .homepage-article-slider .slick-dots li button,
        .homepage-article-slider .slick-dots li button::before {
          width: 10px;
          height: 10px;
        }

        .homepage-article-slider .slick-dots li {
          margin: 0 8px;
        }

        .homepage-article-slider .slick-dots li button {
          padding: 0;
        }

        .homepage-article-slider .slick-dots li button:before {
          font-size: 10px;
          line-height: 10px;
          color: #FFF;
        }

      `}
      </style>
    </div>
  )
}

export default BannerHomeDesktop
